module.exports = __webpack_public_path__ + "img/oto.65868ff5.png";